import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import EarlyAccessForm from '../reuse/form/early_access';
// import Announcement from 'component/content/announcement';


class Nav extends React.Component {
  render () {
    return(
      <section className={' fixed-top' }>
      {/* <Announcement /> */}
      <nav className={"navbar navbar-expand-lg bg-white box-shadow p-0"}>

        <div className="navbar-header">
          <Link to="/" className="navbar-brand text-spacing-2 mr-2">
            <img style={{height: "40px"}} className="hero mx-2" src="/logo.svg" alt="logo svg" />
            <span className="text-black-2">Passive</span><span className="text-primary">Compound</span>
          </Link>  
        </div>

        <button className="navbar-toggler btn btn-primary text-white mr-2" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <i className="fas fa-bars"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">

          <ul className="navbar-nav mr-auto">
            <li className="nav-item active"></li>
          </ul>

          <ul className="navbar-nav my-0 my-lg-0">
            {/* <li className="nav-item">
              <Link to="/login" className="btn btn-outline-primary btn-rounded text-spacing-2 m-2 uppercase"><i className="fa fa-sign-in-alt mr-2"></i>Login</Link>
            </li> */}
            <li className="nav-item">
              <div className="m-2">
                <EarlyAccessForm full_width={true} />
              </div>
              {/* <NavLink to="/login" className="btn btn-tertiary btn-rounded text-white text-spacing-2 m-2 uppercase"><i className="fa fa-paper-plane mr-2"></i>Start free</NavLink> */}
            </li>
          </ul>

        </div>
      </nav>
      </section>
    )
  }
}


export default withRouter(Nav);
